import React from 'react';
import { motion } from 'framer-motion';
import { stats } from '../data/stats';
export function NumbersSection() {
  return <section className="py-20 px-4 bg-navy" data-id="element-165" data-mp="1t1ae6y8uenre">
      <div className="max-w-6xl mx-auto" data-id="element-166" data-mp="1xzlmv5neis81">
        <div className="text-center mb-12" data-id="element-167" data-mp="1xyk9guiwxtn5">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white" data-id="element-168" data-mp="1xxsdhileltwc">
            Numbers Worth Remembering
          </h2>
        </div>
        <dl className="grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-10" data-id="element-169" data-mp="27q6l2rz5xuqf">
          {stats.map((stat, index) => <motion.div key={stat.label} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.25,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className="text-center" data-id="element-170" data-mp="2bpp0574azblc" data-mpi={index}>
              <dt className="sr-only" data-id="element-171" data-mp="meesulvrggyg">{stat.label}</dt>
              <dd data-id="element-172" data-mp="rc81dlkjdn1w">
                <span className="block text-5xl md:text-6xl font-bold text-gold-light tabular-nums" data-id="element-173" data-mp="rbf0h189drro">
                  {stat.value}
                </span>
                <span className="block text-sm text-white/75 mt-2" data-id="element-174" data-mp="1si3cgtakf72e">{stat.label}</span>
              </dd>
            </motion.div>)}
        </dl>
      </div>
    </section>;
}